'use strict'

define ['./apply.scss', './SelfApplyModal.css', './ScammerModal.css'], () ->
  ($q, app_or_apptemplate, stage, RENTAPPLICATION_API_URL, $compile, hotkeys, User, Flash, $rootScope, $scope, $sce, $stateParams, $http, $state, RentappService, $uibModal, $timeout, ApplicationTemplate, $localStorage, $cacheFactory, $window, BETA_FRONTEND_BASE_URL) ->
    $scope.app_or_application_template = app_or_apptemplate
    $scope.stage = stage
    $scope.user_is_editing = !$scope.app_or_application_template.slug
    $scope.submission_errors = $stateParams.submission_errors
    $scope.info_alert_toggled = true
    $scope.current_state = $state.$current.name
    $scope.params_data = $stateParams.params_data or {}
    $scope.submit_label = 'Submit Application'
    $scope.submit_process_label = 'Submitting...'
    $scope.mobile_view = window.innerWidth < 768

    # Open up all sections for mobile display
    $scope.app_or_application_template.form.sections.map((section) ->
      section.active = true
    )

    # TODO: Decide if applicant user edit should fall under beta/classic toggle
    if $scope.app_or_application_template.landlord && $scope.app_or_application_template.landlord.edge_enabled
      if !$scope.user_is_editing
        href = "#{BETA_FRONTEND_BASE_URL}/apply/#{$scope.app_or_application_template.slug}#{if location.search then location.search else ''}"
        location.href = "#{BETA_FRONTEND_BASE_URL}/apply/#{$scope.app_or_application_template.slug}#{if location.search then location.search else ''}"

    if window.location.search.indexOf('?invite=') == 0
      $scope.params_data.invite = window.location.search.split('invite=')[1]
    if window.location.search.indexOf('?bundle=') == 0
      $scope.params_data.bundle = window.location.search.split('bundle=')[1]

    if $scope.user_is_editing
      $scope.submit_label =  'Update Application'
      $scope.submit_process_label = 'Updating...'

    if not $rootScope.user and app_or_apptemplate.slug != 'sample@rentapplication.net'
      $localStorage.apply_app_slug = app_or_apptemplate.slug

    # When reverted back from create account page due to backend validation error
    # focus on first error.
    if $scope.submission_errors
      $timeout () ->
        $("body").find('.has-error :input:first').focus()

    if app_or_apptemplate.possible_scam and $state.$current.name.indexOf('sample') < 0
        $uibModal.open
          template: require("./ScammerModal.jade")
          windowClass: 'scammer-modal'
        .result
    if app_or_apptemplate.landlord && app_or_apptemplate.landlord.name
      $rootScope.title = 'Rental Application For ' + app_or_apptemplate.landlord.name

    if $rootScope.user && $rootScope.user.landlord && app_or_apptemplate.landlord.id == $rootScope.user.landlord.id and $state.$current.name.indexOf('sample') < 0
      if (new Date() - new Date(app_or_apptemplate.created))/1000/60/60 <= 24
        $scope.landlord_username = $rootScope.user.email
        $uibModal.open
          scope: $scope
          template: require("./SelfApplyModal.jade")
          windowClass: 'self-apply-modal'
        .result

    if app_or_apptemplate.custom_css
      head = angular.element('head')
      head.append($compile("<style>{{app_or_application_template.custom_css}}</style>")($scope));

    $rootScope.$broadcast("apptemplate-loaded", { apptemplate: $scope.app_or_application_template})

    if !$scope.app_or_application_template.can_submit
      body = angular.element('body')
      body.addClass('body-no-scroll')

    try
      iframe = window.top != window
    catch e
      iframe = true

    if iframe
      $scope.warning_iframe = true
    
    ### Main submit button method ###
    $scope.submit_app = (application_form) ->
      applicant_email = null
      for section in $scope.app_or_application_template.form.sections
        for field in section.fields
          if field.name == 'applicant_email'
            applicant_email = field.value
          if (application_form[field.name] and application_form[field.name].$invalid) or ($scope.submission_errors and $scope.submission_errors[field.name])
            section.active = true
            section.error = true

      if not application_form.$valid
        if $scope.mobile_view
          first_error_element_name = application_form.$error[Object.keys(application_form.$error)[0]][0]['$name']
          first_error_element = document.getElementsByName(first_error_element_name)[0]
          first_error_element.scrollIntoView()
        return

      if $scope.user_is_editing
        $scope.save_application()
      else
        if Object.keys($scope.params_data).length == 0
          $scope.params_data =
            invite: $stateParams.invite
            bundle: $stateParams.bundle
        if applicant_email
          User.check_available(username: applicant_email).$promise
            .then (user_info) ->
              if !user_info.available
                $state.go("root.applications.create_account", {
                  application_slug: $scope.app_or_application_template.slug,
                  application: app_or_apptemplate,
                  params_data: $scope.params_data,
                  view_state: 'login',
                  applicant_info: user_info.applicant_info
                })
              else
                $state.go("root.applications.create_account", {
                  application_slug: $scope.app_or_application_template.slug,
                  application: app_or_apptemplate,
                  params_data: $scope.params_data,
                  view_state: 'create',
                  applicant_info: { email: applicant_email }
                })
        else
          $state.go("root.applications.create_account", { application_slug: $scope.app_or_application_template.slug, application: app_or_apptemplate, params_data: $scope.params_data })
    
    ### Main edit/save application method ###
    $scope.save_application = () ->
      $scope.submitting_application = true
      $scope.app_or_application_template.$update()
      .then (application) ->
        application_id = application.id
        application_status = application.status
        $rootScope.$broadcast("refresh-applicant-appbundle-table")

        if application.need_applicant_experian_authtoken
          $state.go "root.applications.verify.disclaimer", {application_id: application_id, application: application, context: 'applicant', apply_data: application }, {reload: true}
        else if application.need_applicant_smartmove_auth
          $state.go("root.applications.verify.disclaimer", { 
            application_id: application_id, 
            application: application, 
            context: 'applicant', 
            apply_data: application, 
            vendor: 'smartmove'
          })
          #$rootScope.$broadcast("apptemplate-loaded", { apptemplate: $scope.app_or_application_template})
        else if application.need_applicant_finicity_bank_connection
          $state.go("root.applications.income", { application_id: application_id, application: application })
        else
          $state.go "root.applications.apply_success", {application_id: application_id, application: application }
      .catch (response) ->
        $rootScope.$broadcast("submit-error", {
          action: "save_application"
          app: $scope.app_or_application_template
          response: response
        })
        $scope.submission_errors = response.data
        $timeout () ->
          $("body").find('.has-error :input:first').focus()
        if response.status == 500
          Flash.create('danger', "Unknown Error: Please contact #{$rootScope.SUPPORT_EMAIL} for assistance.", 6000)
          $window.scrollTo(0, 0);
      .finally ->
        $scope.submitting_application = false

    hotkeys.bindTo($scope).add
      combo: 'ctrl+8',
      description: 'Fill application with sample data'
      callback: () ->
        console.log "ctrl 8"
        $scope.fill_sample_data()

    $scope.generate_fake_email = () ->
      chars = 'abcdefghijklmnopqrstuvwxyz1234567890'
      random_chars = [1...12].reduce (x, y) -> 
        x + chars[Math.floor(Math.random() * chars.length)]
      return "#{random_chars}@testing.com"

    $scope.fill_sample_data = () ->
      now = new Date().getTime()
      _by_name =
        "applicant_email":           (f) -> $scope.generate_fake_email()
        "applicant__first_name":     (f) -> "Test"
        "applicant__last_name":      (f) -> "Testing"
        "unit":                      (f) -> "123 Test Rd."
        "current_address__address1": (f) -> "123 Test Rd."
        "current_address__city":     (f) -> "Chicago"
        "current_address__state":    (f) -> "IL"
        "current_address__zip_code": (f) -> "60606"
      _by_id =
        "email":       (f) -> $scope.generate_fake_email()
        "ssn":         (f) -> "123456789"
        "date":        (f) -> "1990-01-01"
        "phone":       (f) -> "1234567890"
        "choice":      (f) -> f.choices[Math.round((Math.random() * (f.choices.length - 1)))].value
        "signature":   (f) -> JSON.stringify({"lx":d,"ly":d,"mx":d+1,"my":d+1} for d in [1...25])
        "signature_new": (f) -> JSON.stringify([{ color: 'black', points: {x: d, y: d, time: now + (d + 4) } for d in [1...25]}])
        "single_line": (f) -> "Testing single line"
        "multi_line": (f) -> "Testing multiline"
        "state": (f) -> "IL"
      _by_validator =
        "phone": (f) -> "1234567890"
        "email": (f) -> $scope.generate_fake_email()
        "zipcode": (f) -> "60606"

      $scope.app_or_application_template.form.sections.forEach (section) ->
        section.fields
        .forEach (f) ->
          f.value = (_by_validator[f.validate] or _by_name[f.name] or _by_id[f.field_id] or () -> f.value)(f)
# validate: phone



// WEBPACK FOOTER //
// ./components/applications/apply/apply.coffee